import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language.substring(0, 2));

  // Update currentLang when i18n.language changes
  useEffect(() => {
    const langCode = i18n.language.substring(0, 2);
    setCurrentLang(langCode);
  }, [i18n.language]);

  const languages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' }
  ];

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    // Store language preference
    localStorage.setItem('i18nextLng', code);
    // No need to setCurrentLang here as the useEffect will handle it
  };

  // Get current language object
  const currentLanguage = languages.find(lang => lang.code === currentLang) || languages[0];

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button 
            className="flex items-center space-x-1 px-2 py-1 rounded-md text-dblift-gray-dark hover:text-dblift-orange focus:outline-none"
          >
            <span>{currentLanguage.flag}</span>
            <span className="hidden md:inline">{currentLanguage.name}</span>
            <ChevronDownIcon className={`
              h-4 w-4 transition-transform
              ${open ? 'transform rotate-180' : ''}
            `} />
          </Popover.Button>
          <Popover.Panel className="absolute right-0 z-10 mt-2 w-40 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="py-1">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => changeLanguage(lang.code)}
                  className={`
                    block w-full text-left px-4 py-2 text-sm hover:bg-dblift-gray-light
                    ${currentLang === lang.code ? 'bg-dblift-gray-light text-dblift-orange' : 'text-dblift-gray-dark'}
                  `}
                >
                  <span className="mr-2">{lang.flag}</span>
                  {lang.name}
                </button>
              ))}
            </div>
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
};

export default LanguageSwitcher;